export default __webpack_public_path__ + "static/media/felicetti.56ab1421.jpg";